import React, { useState, useEffect, useReducer,useRef } from "react";
import MUIDataTable from "mui-datatables";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  SwipeableDrawer,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  DialogContent,
  Dialog,
  TextField,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import DescriptionIcon from "@material-ui/icons/Description";
import CloseIcon from "@material-ui/icons/Close";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import useStyles from "../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useNotification } from "../../../hooks/useNotification.js";
import { useLocation } from "react-router-dom";
import { getFileExtension } from "../../../utils/getextension.js";
import CustomPdfView from "../../../components/pdfViewer/CustomPdfView.js";
import { jwtDecode } from "jwt-decode";
import { IoMdDownload } from "react-icons/io";
import { Autocomplete } from "@material-ui/lab";


export default function InternalJobpostingReferralCandidates() {
  const classes = useStyles();
  const filterRef = useRef(null);
  const location = useLocation();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const queryParams = new URLSearchParams(location.search);
  const requirementId = queryParams.get("requirementId");

  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");
  const [internalJob, setInternalJob] = useState({});
  const [candidateData, setCandidateData] = useState([]);

  const [jobPostingView, setJobpostingView] = useState({
    id: "",
    name: "",
    createdAt: "",
    isActive: "",
  });
  const [resumeFileOpen, setResumeFileOpen] = useState(false);
  const [docFile, setDocFile] = useState("");
  const [page, setPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reducerValue, forceUpdate] = useReducer((x) => x + 1, 0);

  const HeaderElements = () => <>Total : {count}</>;

  const handleResumeFileModalOpen = (file) => {
    // const fullUrl = `${process.env.REACT_APP_AWS_BUCKET_URL}${file}`
    console.log(file);
    setDocFile(file);
    setResumeFileOpen(true);
  };

  const handleResumeFileModalClose = () => {
    setResumeFileOpen(false);
    setDocFile("");
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState([]);

  const handleFromDateChange = (event) => {
    setFromDate(filterRef.current.fromDate.value);
  };

  const handleToDateChange = (event) => {
    setToDate(filterRef.current.toDate.value);
  };

  const resetForm = (e) => {
    filterRef.current.reset();
    setUserId(null);
    fetchData();
  };

  useEffect(() => {
    fetchData();
    getAllUserList();
  }, []);

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setUserName(userList);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  const fetchData = async () => {
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/viewReferredCandidates?requirementId=${requirementId}&page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        setCandidateData(response.data.data);
        setCount(response.data.count);
      }
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setCurrentPage(newPage + 1);
    setLoader(true);

    axios({
      method: "get",
      url: `${process.env.REACT_APP_SERVER}employee/viewReferredCandidates?page=${currentPage}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setCandidateData(response.data.data);
        setCount(response.data.count);
        setLoader(false);
      }

      setLoader(false);
    });
  };

  function getFilterData() {
    const form = filterRef.current;

    if (form["fromDate"].value > form["toDate"].value) {
      handleNotificationCall("info", "Check your selected dates");
      return;
    }

    setLoader(true);
    setCurrentPage(1);
    setPage(0);

    axios({
      method: "get",
      url: `${
        process.env.REACT_APP_SERVER
      }employee/viewReferredCandidates?requirementId=${requirementId}&page=${1}&fromDate=${
        form["fromDate"].value
      }&toDate=${form["toDate"].value}&userId=${userId || ""}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setCandidateData(response.data.data);
          setCount(response.data.count);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  }

  const [state, setState] = useState({
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  const list = (anchor) => (
    <Box sx={{ width: "100%" }} role="presentation">
      <List>
        <Card className={classes.root}>
          <CardHeader>
            <Grid
              container
              direction="row"
              spacing={1}
              className={classes.drawerHeader}
            >
              <Typography variant="subtitle1"> View Requirement</Typography>

              <Grid className={classes.drawerClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  size="14px"
                  onClick={toggleDrawer(anchor, false)}
                />
              </Grid>
            </Grid>
          </CardHeader>

          <CardContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Name:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementName +
                  " (" +
                  internalJob?.uniqueId +
                  ")"}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Experience:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  {internalJob?.experience}
                </Grid>
                {/* {jobPostingView.isActive === true ? (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.green + " " + classes.noPointer}
                    >
                      ACTIVE
                    </Button>
                  </>
                ) : (
                  <>
                    <Button
                      variant="contained"
                      size="small"
                      className={classes.red + " " + classes.noPointer}
                    >
                      INACTIVE
                    </Button>
                  </>
                )} */}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Skills:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.skills}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>Location:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.jobLocation}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Mode of work:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.modeOfWork}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Special hiring:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.specialHiring}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>JD:</Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {internalJob?.requirementJd}
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Requirement Gist:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <div
                  dangerouslySetInnerHTML={{ __html: internalJob?.gist }}
                ></div>
              </Grid>

              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Typography className={classes.boldtext}>
                  Posted Date:
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {moment(internalJob?.createdAt).format("DD-MM-YYYY")}
              </Grid>
            </Grid>
            <CardActions>
              <Grid
                container
                direction="row"
                spacing={2}
                className={classes.drawerFooter}
                width={100}
              >
                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={toggleDrawer(anchor, false)}
                >
                  Close
                </Button>
              </Grid>
            </CardActions>
          </CardContent>
        </Card>
      </List>
    </Box>
  );

  const fileExtension = docFile ? getFileExtension(docFile) : null;

  return (
    <>
      <Grid container direction="row" spacing={2} className={classes.heading}>
        <Grid item xs={9} sm={7} md={8} lg={6}>
          <PageTitle title="Candidates for Internal Job Posting" />
        </Grid>
      </Grid>

      <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <Autocomplete
            className="filterFullWidth"
            options={userName}
            getOptionLabel={(option) => option.fullName}
            value={userName.find((user) => user.id === userId) || null}
            onChange={(event, value) => setUserId(value ? value.id : null)}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="User Name"
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

          <TextField
            name="fromDate"
            label="From"
            InputLabelProps={{ shrink: true }}
            size="small"
            type="date"
            defaultValue={fromDate}
            onChange={(e) => handleFromDateChange(e)}
            className={classes.filterWidth}
          />

          <TextField
            name="toDate"
            label="To"
            InputLabelProps={{ shrink: true }}
            size="small"
            className={classes.filterWidth}
            type="date"
            defaultValue={toDate}
            onChange={handleToDateChange}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              type="submit"
              color="primary"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={resetForm}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <MUIDataTable
            title=""
            options={{
              textLabels: {
                body: {
                  noMatch: "Oops! Matching record could not be found",
                },
              },
              pagination: false,
              sort: false,
              selectableRows: "none",
              search: false,
              filter: false,
              download: false,
              print: false,
              customToolbar: () => <HeaderElements />,
              responsive: mobileQuery === true ? "vertical" : "standard",
            }}
            columns={[
              {
                name: "S.No",
              },
              {
                name: "Referrer Name",
              },
              {
                name: "Candidate Name",
              },
              {
                name: "Email / Mobile No",
              },
              {
                name: "Skills",
              },
              {
                name: "Resume",
              },
              {
                name: "Posted Date",
              },
            ]}
            data={candidateData.map((item, index) => {
              return [
                <>
                  {currentPage !== 0
                    ? 10 * currentPage - 10 + index + 1
                    : index + 1}
                </>,
                <>
                  {getEmpName(item.user)} <br />
                  {item.user.recruiter
                    ? item.user.recruiter.mobile
                    : item.user.employee
                    ? item.user.employee.mobile
                    : " - "}
                </>,
                <>{`${item.firstName} ${item.lastName}`}</>,
                <>
                  {item.email} <br />
                  {item.mobile}
                </>,
                <>{`${item.skills}`}</>,
                <Grid container className={classes.space}>
                  <Grid item xs className={classes.toolAlign}>
                    <Tooltip
                      title="View Resume"
                      placement="bottom"
                      aria-label="view"
                    >
                      <DescriptionIcon
                        className={classes.toolIcon}
                        onClick={() =>
                          handleResumeFileModalOpen(
                            `${process.env.REACT_APP_AWS_BUCKET_URL}${item.resume}`,
                          )
                        }
                      />
                    </Tooltip>
                  </Grid>
                </Grid>,
                moment(item.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
        <SwipeableDrawer
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}
          onOpen={toggleDrawer("right", true)}
          classes={{ paper: classes.drawer }}
        >
          {list("right")}
        </SwipeableDrawer>
      </Grid>

      <Dialog
        aria-labelledby="dialog-title"
        onClose={handleResumeFileModalClose}
        open={resumeFileOpen}
        fullWidth={true}
        maxWidth="md"
        PaperProps={{
          style: {
            width: "100%",
          },
        }}
      >
        <DialogContent>
          <Grid container direction="row" spacing={2}>
            <div
              className={classes.heading + " " + classes.inputRoot}
              style={{
                position: "absolute",
                zIndex: 1,
                background: "#fff",
                top: 0,
                padding: "6px 30px",
              }}
            >
              <Typography variant="subtitle2" className={classes.inputRoot}>
                Resume
                {docFile !== "" && (
                  <a
                    style={{ fontSize: "1.3rem", color: "#29b229" }}
                    href={docFile}
                  >
                    <IoMdDownload />
                  </a>
                )}
              </Typography>
              <div className={classes.drawerClose}>
                <CloseIcon
                  className={classes.closeBtn}
                  onClick={handleResumeFileModalClose}
                />
              </div>
            </div>
            <Grid item xs={12}>
              {docFile === "" ? (
                <div style={{ color: "red", marginTop: "50px" }}>
                  <p>No File found here...</p>
                </div>
              ) : fileExtension === "pdf" ? (
                <CustomPdfView resumeUrl={docFile} />
              ) : (
                <div
                  className={classes.iframediv}
                  style={{ marginTop: "40px" }}
                >
                  <iframe
                    className="iframe"
                    src={
                      "https://docs.google.com/gview?url=" +
                      docFile +
                      "&embedded=true"
                    }
                    title="File"
                    width="100%"
                    height="500"
                    sandbox="allow-scripts allow-same-origin"
                  >
                    {" "}
                  </iframe>
                  <div className={classes.iframeLogo}></div>
                </div>
              )}
            </Grid>

            <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
              <Button
                variant="contained"
                size="small"
                color="secondary"
                onClick={handleResumeFileModalClose}
              >
                Close
              </Button>
            </div>
          </Grid>
        </DialogContent>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
